import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, ORDERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const FoodicsShipmentsList = () => {
	const defaultSort = useMemo(() => [{ id: 'createdAt', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				showOnMap: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				filterRemovable: false,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.SHIPMENT_STATUS,
				showOnMobile: true,
				width: 200,
				showOnMap: true
			},
			{
				Header: 'salesChannel',
				accessor: 'salesChannelName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SALES_CHANNEL_ACTIVE,
				width: 100,
				renderCell: ListComponents.SALES_CHANNEL_LOGO,
				show: false,
				roleName: 'SalesChannelModule'
			},
			{
				Header: 'pickupLocation',
				accessor: 'pickupLocation',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PICKUP_LOCATION,
				width: 100
			},
			{
				Header: 'branchName',
				accessor: 'branchName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRANCHES,
				width: 90,
				show: false,
				roleName: 'BranchModule'
			},
			{
				Header: 'warehouseName',
				accessor: 'warehouseName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WAREHOUSES,
				width: 90,
				roleName: 'MultiWarehouseModule'
			},
			{
				Header: 'brandName',
				accessor: 'storeName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRAND_NAME,
				width: 100,
				show: false,
				renderCell: ListComponents.BRAND_LOGO,
				roleName: 'BrandingModule'
			},
			{
				Header: 'originCity',
				accessor: 'originCity',
				filterType: FilterType.string,
				show: false
			},
			{ Header: 'customerName', accessor: 'name', filterType: FilterType.string, width: 100 },
			{
				Header: 'customerEmail',
				accessor: 'email',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'customerPhone',
				accessor: 'phone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE,
				show: false
			},
			{ Header: 'customerAddress', accessor: 'address', filterType: FilterType.string, width: 130, show: false },
			{
				Header: 'destinationCountry',
				accessor: 'countryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				show: false
			},
			{
				Header: 'destinationCity',
				accessor: 'cityName',
				filterType: FilterType.multiSelection,
				width: 100,
				show: false
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				filterType: FilterType.float,
				width: 120,
				renderCell: ListComponents.CURRENCY,

				showOnMap: true
			},
			{
				Header: 'packageCount',
				accessor: 'packageCount',
				filterType: FilterType.number,
				width: 50,
				show: false
			},
			{
				Header: 'weight',
				accessor: 'weight',
				filterType: FilterType.number,
				width: 50,
				show: false
			},
			{
				Header: 'packageSize',
				accessor: 'maxPackageSize',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'couponCode',
				accessor: 'couponCode',
				filterType: FilterType.string,
				roleName: 'EnterprisePackage',
				show: false
			},
			{
				Header: 'skus',
				accessor: 'skuList',
				filterType: FilterType.string,
				width: 70,
				roleName: 'EnterprisePackage',
				show: false
			},
			{
				Header: 'quantities',
				accessor: 'qtyList',
				filterType: FilterType.number,
				width: 70,
				roleName: 'EnterprisePackage',
				show: false
			},
			{
				Header: 'lat',
				accessor: 'lat',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'lng',
				accessor: 'lng',
				filterType: FilterType.string,
				width: 70,
				show: false
			},
			{
				Header: 'drivingDistance',
				accessor: 'drivingDistance',
				filterType: FilterType.float,
				width: 70,
				show: false
			},

			{ Header: 'district', accessor: 'district', filterType: FilterType.string, width: 100, show: false },
			{ Header: 'state', accessor: 'state', filterType: FilterType.string, width: 100, show: false },
			{ Header: 'region', accessor: 'region', filterType: FilterType.string, width: 100, show: false },
			{
				Header: 'areaName',
				accessor: 'areaName',
				filterType: FilterType.string,
				show: false,
				roleName: 'OMSModule'
			},

			{
				Header: 'paymentMethod',
				accessor: 'paymentMethod',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PAYMENT_METHOD_FOR_LIST,
				width: 100,
				showOnMap: true
			},
			{
				Header: 'totalDue',
				accessor: 'totalDue',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'shippingDiscount',
				accessor: 'shippingDiscountAmount',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'discountAmount',
				accessor: 'discountAmount',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},

			{
				Header: 'subtotal',
				accessor: 'subTotal',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CURRENCY,
				width: 40,
				show: false
			},
			{
				Header: 'lastComment',
				accessor: 'lastComment',
				filterType: FilterType.string,
				renderCell: ListComponents.LAST_COMMENT,
				width: 100,
				show: false,
				roleName: 'EnterprisePackage'
			},
			{ Header: 'comments', accessor: 'comments', filterType: FilterType.string, width: 120, show: false },
			{
				Header: 'shippingDescription',
				accessor: 'shippingDescription',
				filterType: FilterType.string,
				width: 120,
				show: false
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.TRACKING_URL
			},
			{
				Header: 'deliveryName',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				width: 90,
				renderCell: ListComponents.DC_LOGO,
				show: false
			},
			{
				Header: 'refundAmount',
				accessor: 'refundAmount',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'dcReturnReason',
				accessor: 'dcReturnReason',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'customerReturnReason',
				accessor: 'returnReasonOptions',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'customerReturnComment',
				accessor: 'returnReason',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'returnType',
				accessor: 'returnType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.RETURN_TYPE,
				width: 90,
				show: false
			},
			{
				Header: 'reverseShipment',
				accessor: 'isReverseShipment',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 90,
				show: false
			},
			{
				Header: 'returnDate',
				accessor: 'returnDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 90,
				show: false
			},
			{
				Header: 'returnCreateDate',
				accessor: 'returnCreateDate',
				filterType: FilterType.date,
				width: 90,
				show: false
			},

			{
				Header: 'shippingCost',
				accessor: 'OTOdeliveryFee',
				filterType: FilterType.number,
				width: 100,
				renderCell: ListComponents.CURRENCY,
				renderCellProps: {
					currency: 'undefined'
				},
				show: false
			},
			{
				Header: 'shippingAmount',
				accessor: 'shippingAmount',
				filterType: FilterType.float,
				width: 120,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'driverPhone',
				accessor: 'driverPhone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE,
				roleName: 'OTOFlexModule',
				show: false
			},
			{
				Header: 'driverName',
				accessor: 'driverName',
				filterType: FilterType.string,
				width: 100,
				roleName: 'OTOFlexModule',
				show: false
			},
			{
				Header: 'onHoldComment',
				accessor: 'onHoldComment',
				filterType: FilterType.string,
				width: 105,
				show: false
			},
			{
				Header: 'onHoldReason',
				accessor: 'onHoldReason',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ON_HOLD_REASON_CONFIG,
				show: false
			},
			{
				Header: 'cancelComment',
				accessor: 'cancelComment',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'cancelReason',
				accessor: 'cancelReason',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CANCEL_REASON_CONFIG,
				width: 90,
				show: false
			},
			{
				Header: 'failedDeliveryComment',
				accessor: 'failedDeliveryComment',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'failedReason',
				accessor: 'failedReason',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'awbPrinted',
				accessor: 'printed',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 120,
				show: false,
				roleName: ['ScalePackage', 'EnterprisePackage']
			},
			{
				Header: 'modifiedDate',
				accessor: 'modifiedAt',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				width: 80,
				show: false
			},
			{
				Header: 'modifiedBy',
				accessor: 'modifiedBy',
				filterType: FilterType.string,
				width: 80,
				show: false
			},
			{
				Header: 'CODStatus',
				accessor: 'CODStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COD_STATUS,
				renderCell: ListComponents.STATUS,
				width: 100,
				show: false
			},
			{
				Header: 'returnStatus',
				accessor: 'returnApprovalStatus',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.RETURN_APPROVAL_STATUS,
				show: false
			},
			{
				Header: 'ecommerceStatus',
				accessor: 'ecomStatus',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				roleName: 'SalesChannelModule',
				show: false
			},
			{
				Header: 'addressConfirm',
				accessor: 'confirmationStatus',
				enumName: ENUMS.CONFIRMATION_STATUS_LIST_ENUM,
				renderCell: ListComponents.SHIPMENT_STATUS,

				filterType: FilterType.enumMulti,
				width: 100,
				show: false,
				roleName: 'SMSModule'
			},
			{
				Header: 'codOrderConfirmation',
				accessor: 'orderConfirmation',
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.SHIPMENT_STATUS,

				filterType: FilterType.enumMulti,
				width: 100,
				show: false,
				roleName: 'OMSModule'
			},
			{
				Header: 'inventoryStatus',
				accessor: 'inventoryStatus',
				enumName: ENUMS.INVENTORY_STATUS,
				filterType: FilterType.enumMulti,
				width: 70,
				roleName: 'IMSModule',
				show: false
			},
			{
				Header: 'sortingStatus',
				accessor: 'sortingStatus',
				enumName: ENUMS.SORTING_STATUS,
				filterType: FilterType.enumMulti,
				width: 70,
				roleName: 'WMS_BinTracking',
				show: false
			},
			{
				Header: 'sortingBinId',
				accessor: 'sortingBinId',
				filterType: FilterType.string,
				width: 70,
				roleName: 'WMS_BinTracking',
				show: false
			},
			{
				Header: 'packingStatus',
				accessor: 'packingStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PACKING_STATUS,
				width: 100,
				roleName: ['WMSModule', 'WMSAdvanceModule'],
				show: false
			},
			{
				Header: 'pickerName',
				accessor: 'pickerName',
				filterType: FilterType.string,
				width: 90,
				roleName: ['WMSModule', 'WMSAdvanceModule'],
				show: false
			},
			{
				Header: 'pickerGroup',
				accessor: 'pickerGroup',
				filterType: FilterType.string,
				width: 90,
				show: false,
				roleName: 'WMSAdvanceModule'
			},
			{
				Header: 'waveId',
				accessor: 'waveID',
				filterType: FilterType.number,
				width: 100,
				show: false,
				roleName: 'WMS_BinTracking',
				showCopyButton: true
			},
			{
				Header: 'dispatchingUnit',
				accessor: 'palletNo',
				filterType: FilterType.number,
				width: 70,
				roleName: ['WMSModule', 'WMSAdvanceModule'],
				show: false
			},
			{
				Header: 'rating',
				accessor: 'rating',
				filterType: FilterType.number,
				roleName: 'SMSModule',
				show: false
			},
			{
				Header: 'shipmentRating',
				accessor: 'shipmentRating',
				filterType: FilterType.number,
				roleName: 'SMSModule',
				show: false
			},
			{
				Header: 'rateComment',
				accessor: 'rateComment',
				filterType: FilterType.string,
				roleName: 'SMSModule',
				show: false
			},
			{
				Header: 'shipmentCreationDate',
				accessor: 'shipmentCreationDate',
				filterType: FilterType.date,
				showOnMobile: true,
				show: false,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'deliveryDate',
				accessor: 'deliveryDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'preparationTime',
				accessor: 'preparationTime',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'orderDetailsPrinted',
				accessor: 'orderDetailsPrinted',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 80,
				show: false,
				roleName: ['ScalePackage', 'EnterprisePackage']
			},
			{
				Header: 'trackingNumber',
				accessor: 'trackingNumber',
				filterType: FilterType.string
			},
			{
				Header: 'driverDeliveryNote',
				accessor: 'driverDeliveryNote',
				filterType: FilterType.string
			},
			{
				Header: 'orderDeliveryNote',
				accessor: 'orderDeliveryNote',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'nationalIdNumber',
				accessor: 'nationalID',
				filterType: FilterType.string,
				width: 100,
				roleName: '/column/nationalID'
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'createdDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(29, 'day').startOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[columns]
	);

	return (
		<div>
			<PageHeader
				title="foodicsShipments"
				lordIcon="https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shipments-icon-new.json.gz"></PageHeader>
			<DynamicList
				id={DYNAMICLISTS.FOODICS_ORDERS}
				columns={columns}
				fetchUrl={ORDERS.GET_FOODICS_ORDER_LIST}
				defaultFilters={defaultFilters}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ORDER}
				exportName="foodicsShipments"
			/>
		</div>
	);
};

export default FoodicsShipmentsList;
